import { Properties as CssProps } from "csstype";
import React, { FC, ReactNode } from "react";

interface Props {
    children: ReactNode;
    className?: string;
    backgroundClass?: string;
    style?: CssProps;
}
const Container: FC<Props> = ({ children, className, backgroundClass, style }: Props) => (
    <div className={`${backgroundClass || ""} w-full`} style={style}>
        <div className={`container mx-auto px-3 py-4 pb-5 xl:px-10 uwd:w-2/3 ${className || ""}`}>{children}</div>
    </div>
);

export default Container;
